import { getCustomerMe, putCustomerMe } from "apis/customerApi";
import { doCall } from "common/genericSaga";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  CUSTOMER_ME_PATCH_REQUESTED,
  CUSTOMER_ME_PATCH_REQUEST_FAILED,
  CUSTOMER_ME_REQUESTED,
  CUSTOMER_ME_REQUEST_FAILED,
  receiveCustomerMe,
  receiveUpdateCustomerMe
} from "./customerActions";

export function* doRequestCustomerMe(action, requestInfo) {
  const customer = yield call(getCustomerMe, requestInfo);
  yield put(receiveCustomerMe(customer));
}

export function* doUpdateCustomerMe(action, requestInfo) {
  const customer = yield call(putCustomerMe, requestInfo, action.payload);
  const result = { ...action.payload, ...customer }; // merging request payload with response to preserve explicit null values (eg birthDate )
  yield put(receiveCustomerMe(result));
  yield put(receiveUpdateCustomerMe(result));
}

export function* watchCustomerMe() {
  yield all([
    takeLatest(CUSTOMER_ME_REQUESTED, doCall(doRequestCustomerMe, CUSTOMER_ME_REQUEST_FAILED)),
    takeLatest(CUSTOMER_ME_PATCH_REQUESTED, doCall(doUpdateCustomerMe, CUSTOMER_ME_PATCH_REQUEST_FAILED))
  ]);
}
